"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_options_core_1 = require("owa-options-core");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(function isSignatureOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    return (optionState.editorViewState.isDirty ||
        owa_options_core_1.getFallbackValueIfNull(optionState.signNewMails, userOptions.AutoAddSignature) !==
            userOptions.AutoAddSignature ||
        owa_options_core_1.getFallbackValueIfNull(optionState.signReplies, userOptions.AutoAddSignatureOnReply) !==
            userOptions.AutoAddSignatureOnReply);
});
//# sourceMappingURL=isSignatureOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-signature-option/lib/utils/isSignatureOptionDirty.js
// module id = 5011
// module chunks = 2